export default __webpack_public_path__ + "static/media/group_score.e355fe08.svg";